import { PrintCardMenu } from './print-card-menu';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';

export class PlantlifePrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.BebasNeuePro.Regular_400, FONT.BebasNeuePro.SemiBold_600, FONT.BebasNeueProExpanded.Bold_700];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/fgy7byg.css';
  }

  override shouldFetchVariantAssets(): boolean {
    return true;
  }

  /**
   * Brand asset should be displayed if available - no product fallback.
   */
  override variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }
}
